import { Pipe, PipeTransform } from '@angular/core';
import { Incident } from 'src/generated/graphql';
import { Team } from './incident-assign.component';

// Filter teams to returl only assigned values for Manager user role
@Pipe({ name: 'teamAssignee' })
export class TeamAssigneePipe implements PipeTransform {
  transform(teams: Team[], incident: Incident): Team[] {
    teams.map((team) => {
      const filteredItems = team.items.filter((item) => {
        return incident.assignees.some(
          (a) => a.tenantUserId === item.value.tenantUserId,
        );
      });
      team.items = filteredItems;
      if (team.items.length > 0) { 
        return team;
      }
    });
    return teams;
  }
}
